module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABmBAMAAACtqwUGAAAAElBMVEVHcEwKlmAspHZkuplMsImQy7RYo86BAAAAAXRSTlMAQObYZgAAAJRJREFUSMfd07kNgDAMBVCHkJ6zhw3CBrAB7L8MSU1s6YMFJC5/4ycfROVX3YZK5CbEXSI/Qt4k8oXJZyaPbf01djHfnzMN09boMOkGcwA40jQnkEm/ZzqGU4HMeJsjwGwFJuXBBJZ+K1+BX5F+rmfmlvpdqwXdvoTuwCY5KHcpEhSeXDZQrwCVVj8AUPsGdFSAllQnc9ofHIlv5ywAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrowLeft.png
// module id = f/DI
// module chunks = 1